module.exports = __webpack_public_path__ + "img/campanule.9fb7f3d5.jpg";